import { Badge, Button, Icon } from "antd";

import React, { MouseEvent } from "react";

import style from "./index.module.scss";
import {
    closeSession,
    errorMessage,
    FormatTime,
    ResultMessage,
    useRequestFn
} from "../../../../polyfills";
import { SimpleSessionItem } from "../../../../types";
import useUpdateSession from "../../../../Utils/useUpdateSession";
import { useSetAtom } from "jotai";
import { curSessionIdAtom } from "../../../../store";

interface ListItemProps {
    item: SimpleSessionItem;
    onGotoDetail(): void;
}

export default function ListItem({ item, onGotoDetail }: ListItemProps) {
    const sessionManager = useUpdateSession();
    const setCurSessionId = useSetAtom(curSessionIdAtom);

    //关闭会话
    const [onClose, { loading }] = useRequestFn(async (e: MouseEvent) => {
        e.stopPropagation();

        try {
            await closeSession(item.guid);
            setCurSessionId(undefined);
            sessionManager.removeSession(item.guid);
        } catch (e) {
            ResultMessage.error(errorMessage(e));
        }
    });

    return (
        <div className={style.root} onClick={onGotoDetail} role="button">
            <div className={style.header}>
                <div className={style.nameWrapper}>
                    <Badge dot={item.hasNewMessage}>
                        <span className={style.name}>
                            {item.sessionTopic} （{item.userNo}）
                        </span>
                    </Badge>
                </div>

                <div className={style.time}>
                    <div>
                        {!!item.lastSessionTime &&
                            FormatTime(item.lastSessionTime)}
                    </div>

                    <Button type="link" disabled={loading} onClick={onClose}>
                        <Icon type="close" className={style.ellipsisIcon} />
                    </Button>
                </div>
            </div>

            <div className={style.msg}>{item.lastMsgContent ?? "暂无记录"}</div>
        </div>
    );
}
